import { FC } from 'react';
import { Card } from '@mui/material';

import Modal from 'components/common/Modal';
import useScreen from 'hooks/useScreen';
import MessageIcon from 'components/common/icons/bulk/Message';

interface Props {
  onClose: () => void;
  bgColor?: string;
  fontColor: string;
  termsAndConditions?: string;
}

const TermsAndConditionsModal: FC<Props> = ({ onClose, termsAndConditions }) => {
  const { isMobile } = useScreen();

  return (
    <Modal hasButtons={false} maxWidth={700} fullScreen={isMobile} icon={<MessageIcon />} onClose={onClose}>
      <Card>
        <div dangerouslySetInnerHTML={{ __html: termsAndConditions as unknown as TrustedHTML }}></div>
      </Card>
    </Modal>
  );
};

export default TermsAndConditionsModal;
